export interface IContainerTypeModel {
  uuid: string;
  name: string
  isScreen: boolean
  availableCount: number;
  hasAvailableContainers: boolean;
}

export class ContainerTypeModel implements IContainerTypeModel {
  uuid: string;
  name: string
  isScreen: boolean
  availableCount: number;
  hasAvailableContainers: boolean;

  constructor(data: IContainerTypeModel) {
    this.uuid = data.uuid;
    this.name = data.name;
    this.isScreen = data.isScreen;
    this.availableCount = data.availableCount;
    this.hasAvailableContainers = this.availableCount > 0;
  }
}